/**
 * Create poll element from generic container
 *
 * @param {object} element
 * @returns {{type: string, question: *, answers: (*|{id: number, htmlText: *}[])}}
 */
const createPollFromContainer = (element) => {
    const title = element.elements.find((item) => item.type === 'title');
    const answers = element.elements.find((item) => item.type === 'unordered-list');

    return {
        type: 'poll',
        question: title,
        answers:
            answers &&
            [...answers.htmlText.match(new RegExp('<li>([^<]+)', 'gmi'))].map((match, index) => {
                return {
                    id: index,
                    htmlText: match.replace('<li>', '').trim()
                };
            })
    };
};

/**
 * Check whether an element is a poll and transform it accordingly
 * @param {object} element
 * @returns {object} transformed element
 */
const transformPoll = (element) => {
    if (element.type === 'container' && element.style && element.style.containerType === '_infobox_poll') {
        return createPollFromContainer(element);
    }
    return element;
};

export {transformPoll};
